AgrimarketServices.service('elementInfoMarketHomePageService', ['$rootScope', '$http', '$location', 'currentUserFactory', 'configurationFactory',
	function ($rootScope, $http, $location, currentUserFactory, configurationFactory) {

	    var SendRequest = function (configfile, callback) {
	        $http(configfile)
				.success(function (data) {
				    callback(data, null);
				})
				.error(function (data, status) {
				    callback(data, status);
				});
	    };
	    this.GetElementInfoMarketHomePage = function (callback) {
	        var config = {
	            method: 'GET',
	            url: configurationFactory.Url['Api'] + 'ElementInfoMarketHomePage/GetElementInfoMarketHomePage'
	        };
	        SendRequest(config, callback);
	    };

	    this.SaveElementInfoMarketHomePage = function (lstElementInfoMarketHomePage, callback) {
	        var config = {
	            method: 'POST',
	            data: lstElementInfoMarketHomePage,
	            url: configurationFactory.Url['Api'] + 'ElementInfoMarketHomePage/SaveElementInfoMarketHomePage'
	        };
	        SendRequest(config, callback);
	    };
	}]);